import React from 'react'
import { FlexRow, Icon, LinkButton } from 'elements'

export default function Banner({ children, onClose, ...props }) {
  return (
    <FlexRow
      bg="secondary.0"
      color="background.0"
      borderRadius="small"
      flex="0 0 auto"
      pl="xlarge"
      pr="gigantic"
      py="medium"
      position="relative"
      {...props}
    >
      <FlexRow position="absolute" right="medium" top="25%">
        <LinkButton onClick={onClose}>
          <Icon name="x" />
        </LinkButton>
      </FlexRow>
      {children}
    </FlexRow>
  )
}
